
/* eslint-disable sort-keys */
const StandaloneViewDetailsModal = {
  parts: ['header', 'headerTitle', 'body', 'gallery', 'details'],
  baseStyle: {
    /** Match ConfigurationSelector `galleryPanelHeader` + panel `gallery-detail` header padding (20px / 24px). */
    header: {
      alignItems: 'center',
      display: 'flex',
      flexShrink: 0,
      gap: 4,
      maxH: {base: '60px', lg: 'unset'},
      minH: {base: '60px', lg: 'unset'},
      overflow: 'hidden',
      paddingX: 6,
      paddingY: {base: 5, lg: 6},
    },
    headerTitle: {
      color: 'grayAlpha.90',
      flex: 1,
      fontSize: {base: '16px', lg: 'md'},
      fontWeight: {base: 500},
      lineHeight: '1.4',
      minWidth: 0,
    },
    body: {
      padding: 0,
      overflowY: 'auto',
    },
    gallery: {
      width: '100%',
    },
    details: {
      paddingX: 0,
      paddingTop: 8,
    },
  },
};

export default StandaloneViewDetailsModal;
